import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, signal } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PasswordConfiguration } from '../../models/parametrizacion-api.model';
import { ParametrizacionApiService } from '@app/core/services/parametrizacion-api.service';

@Component({
  selector: 'motor-calculo-password-entry-parametrization',
  templateUrl: './password-entry-parametrization.component.html',
  styleUrls: ['./password-entry-parametrization.component.scss']
})
export class PasswordEntryParametrizationComponent implements OnInit, OnChanges {
  @Input() reloadLog: boolean = false;
  @Input() formValue: PasswordConfiguration;
  @Output() formSubmit = new EventEmitter<PasswordConfiguration>()

  readonly #formBuilder = inject(FormBuilder);
  readonly #parametrizacionApi = inject(ParametrizacionApiService);

  passwordEntries = this.#formBuilder.group({
    urlValidation: [3, [Validators.min(0)]],
    numbersOfAttemps: [0, [Validators.min(0)]],
    waitingTime: [0, [Validators.min(0)]],
    numbersOfCycles: [0],
    passwordRenewalFrequency: [0, [Validators.min(0)]],
    maxAttempsMesage: [''],
    blockedUserMessage: [''],
    passwordRecoveryInstructions: [''],
    unauthorizedUserMessage: [''],
    loggedUserMessage: [''],
  });

  agentID = signal('');
  agentName = signal('');
  agentProfile = signal('');
  logDate = signal('');


  get invalidForm(): boolean {
    return this.passwordEntries.invalid;
  }


  ngOnInit(): void {
    this.#getBitacora();
  }

  ngOnChanges(value): void {
    if (value['reloadLog'] && value['reloadLog'].currentValue) {
      this.#getBitacora();
    }

    if (value['formValue'] && value['formValue'].currentValue) {
      this.passwordEntries.patchValue({
        urlValidation: this.formValue.urlValidation,
        numbersOfAttemps: this.formValue.numbersOfAttemps,
        waitingTime: this.formValue.waitingTime,
        numbersOfCycles: this.formValue.numbersOfCycles,
        passwordRenewalFrequency: this.formValue.passwordRenewalFrequency,
        maxAttempsMesage: this.formValue.maxAttempsMesage,
        blockedUserMessage: this.formValue.blockedUserMessage,
        passwordRecoveryInstructions: this.formValue.passwordRecoveryInstructions,
        unauthorizedUserMessage: this.formValue.unauthorizedUserMessage,
        loggedUserMessage: this.formValue.loggedUserMessage
      });
    }
  }


  onSubmit(): void {
    if (this.invalidForm) return;

    this.formSubmit.emit(this.passwordEntries.value as PasswordConfiguration);
  }

  #getBitacora() {
    this.#parametrizacionApi.getBitacora().subscribe({
      next: (response) => {
        this.agentID.set(response.id_agente);
        this.agentName.set(response.nombre_agente);
        this.agentProfile.set(response.perfil_agente);
        this.logDate.set(response.fecha_registro.toString());
      }
    })
  }

}
